(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["qc-collection-premium"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('qc-orbit-showcase')) {
    class QcOrbitShowcase extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.controller = new AbortController();
        this.signal = this.controller.signal;
        this.stage = this.querySelector('[data-qc-stage]');
        this.cards = Array.from(this.querySelectorAll('[data-qc-card]'));
        this.dots = Array.from(this.querySelectorAll('[data-qc-dot]'));
        this.currentLabels = Array.from(this.querySelectorAll('[data-qc-current]'));
        this.prevButton = this.querySelector('[data-qc-prev]');
        this.nextButton = this.querySelector('[data-qc-next]');
        this.activeIndex = 0;
        this.autoplayTimer = null;
        this.isInView = true;
        this.isHovered = false;
        this.isFocused = false;
        this.isDragging = false;
        this.dragStartX = 0;
        this.dragDelta = 0;
        this.ignoreNextClick = false;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

        if (!this.stage || this.cards.length === 0) {
          this.reveal();
          return;
        }

        this.layoutCards(false);
        this.bindEvents();
        this.observe();
        this.startAutoplay();
      }

      bindEvents() {
        if (this.prevButton) {
          this.prevButton.addEventListener('click', () => this.goTo(this.activeIndex - 1, 'manual'), { signal: this.signal });
        }

        if (this.nextButton) {
          this.nextButton.addEventListener('click', () => this.goTo(this.activeIndex + 1, 'manual'), { signal: this.signal });
        }

        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => this.goTo(Number(dot.dataset.qcDot), 'manual'), { signal: this.signal });
        });

        this.cards.forEach((card, index) => {
          card.addEventListener(
            'click',
            (event) => {
              if (this.ignoreNextClick) {
                event.preventDefault();
              }
            },
            { signal: this.signal }
          );

          card.addEventListener(
            'pointermove',
            (event) => {
              if (!this.finePointer || this.reducedMotion || index !== this.activeIndex || this.isDragging) return;
              if (event.target.closest('.qc-orbit__cta')) {
                this.resetTilt(card);
                return;
              }
              this.updateTilt(card, event);
            },
            { passive: true, signal: this.signal }
          );

          card.addEventListener('pointerleave', () => this.resetTilt(card), { signal: this.signal });
        });

        this.stage.addEventListener('pointerdown', (event) => this.onPointerDown(event), { signal: this.signal });
        this.stage.addEventListener('pointermove', (event) => this.onPointerMove(event), { signal: this.signal });
        this.stage.addEventListener('pointerup', (event) => this.onPointerUp(event), { signal: this.signal });
        this.stage.addEventListener('pointercancel', (event) => this.onPointerUp(event), { signal: this.signal });

        this.stage.addEventListener(
          'keydown',
          (event) => {
            if (event.key === 'ArrowLeft') {
              event.preventDefault();
              this.goTo(this.activeIndex - 1, 'manual');
            }
            if (event.key === 'ArrowRight') {
              event.preventDefault();
              this.goTo(this.activeIndex + 1, 'manual');
            }
          },
          { signal: this.signal }
        );

        this.addEventListener(
          'pointerenter',
          () => {
            this.isHovered = true;
            this.stopAutoplay();
          },
          { signal: this.signal }
        );

        this.addEventListener(
          'pointerleave',
          () => {
            this.isHovered = false;
            this.startAutoplay();
          },
          { signal: this.signal }
        );

        this.addEventListener(
          'focusin',
          () => {
            this.isFocused = true;
            this.stopAutoplay();
          },
          { signal: this.signal }
        );

        this.addEventListener(
          'focusout',
          () => {
            window.setTimeout(() => {
              this.isFocused = this.contains(document.activeElement);
              this.startAutoplay();
            }, 0);
          },
          { signal: this.signal }
        );

        document.addEventListener(
          'visibilitychange',
          () => {
            if (document.hidden) this.stopAutoplay();
            else this.startAutoplay();
          },
          { signal: this.signal }
        );
      }

      observe() {
        if (this.reducedMotion || !('IntersectionObserver' in window)) {
          this.reveal();
          return;
        }

        this.classList.add('is-observed');
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              this.isInView = entry.isIntersecting;
              if (entry.isIntersecting) {
                this.reveal();
                this.startAutoplay();
              } else {
                this.stopAutoplay();
              }
            });
          },
          { threshold: 0.18 }
        );
        this.observer.observe(this);
      }

      reveal() {
        this.classList.add('is-visible');
      }

      getWrappedIndex(index) {
        const length = this.cards.length;
        return ((index % length) + length) % length;
      }

      getRelativeSlot(index) {
        const length = this.cards.length;
        let difference = index - this.activeIndex;

        if (difference > length / 2) difference -= length;
        if (difference < -length / 2) difference += length;

        if (difference < -2 || difference > 2) return 'hidden';
        return String(difference);
      }

      layoutCards(announce = true) {
        this.cards.forEach((card, index) => {
          const slot = this.getRelativeSlot(index);
          const isActive = index === this.activeIndex;
          card.dataset.slot = slot;
          card.classList.toggle('is-active', isActive);
          card.tabIndex = isActive ? 0 : -1;
          card.setAttribute('aria-hidden', isActive ? 'false' : 'true');
          if (!isActive) this.resetTilt(card);
        });

        this.dots.forEach((dot, index) => {
          const isActive = index === this.activeIndex;
          dot.classList.toggle('is-active', isActive);
          if (isActive) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });

        this.currentLabels.forEach((label) => {
          label.textContent = String(this.activeIndex + 1).padStart(2, '0');
        });

        if (announce) this.restartAutoplay();
      }

      goTo(index, source = 'manual') {
        if (this.cards.length < 2) return;
        this.activeIndex = this.getWrappedIndex(index);
        this.layoutCards(source === 'manual');
      }

      updateTilt(card, event) {
        const rect = card.getBoundingClientRect();
        const x = (event.clientX - rect.left) / rect.width;
        const y = (event.clientY - rect.top) / rect.height;
        const rotateY = (x - 0.5) * 7;
        const rotateX = (0.5 - y) * 5;

        card.style.setProperty('--qc-tilt-x', `${rotateX}deg`);
        card.style.setProperty('--qc-tilt-y', `${rotateY}deg`);
        card.style.setProperty('--qc-image-x', `${(x - 0.5) * 8}px`);
        card.style.setProperty('--qc-image-y', `${(y - 0.5) * 6}px`);
        card.style.setProperty('--qc-pointer-x', `${x * 100}%`);
        card.style.setProperty('--qc-pointer-y', `${y * 100}%`);
      }

      resetTilt(card) {
        card.style.setProperty('--qc-tilt-x', '0deg');
        card.style.setProperty('--qc-tilt-y', '0deg');
        card.style.setProperty('--qc-image-x', '0px');
        card.style.setProperty('--qc-image-y', '0px');
        card.style.setProperty('--qc-pointer-x', '72%');
        card.style.setProperty('--qc-pointer-y', '28%');
      }

      onPointerDown(event) {
        if (this.cards.length < 2 || event.button !== 0) return;
        this.isDragging = true;
        this.dragStartX = event.clientX;
        this.dragDelta = 0;
        this.ignoreNextClick = false;
        this.stopAutoplay();
      }

      onPointerMove(event) {
        if (!this.isDragging) return;
        this.dragDelta = event.clientX - this.dragStartX;
        if (Math.abs(this.dragDelta) <= 7) return;

        this.ignoreNextClick = true;
        this.stage.classList.add('is-dragging');
        if (!this.stage.hasPointerCapture(event.pointerId)) {
          this.stage.setPointerCapture(event.pointerId);
        }

        const resistance = Math.max(-90, Math.min(90, this.dragDelta * 0.32));
        this.stage.style.setProperty('--qc-drag-shift', `${resistance}px`);
      }

      onPointerUp(event) {
        if (!this.isDragging) return;
        this.isDragging = false;
        this.stage.classList.remove('is-dragging');
        this.stage.style.setProperty('--qc-drag-shift', '0px');

        if (this.stage.hasPointerCapture(event.pointerId)) {
          this.stage.releasePointerCapture(event.pointerId);
        }

        if (Math.abs(this.dragDelta) > 42) {
          this.goTo(this.activeIndex + (this.dragDelta < 0 ? 1 : -1), 'manual');
        } else {
          this.startAutoplay();
        }

        window.setTimeout(() => {
          this.ignoreNextClick = false;
        }, 0);
      }

      canAutoplay() {
        return (
          this.dataset.autoplay === 'true' &&
          !this.reducedMotion &&
          this.cards.length > 1 &&
          this.isInView &&
          !this.isHovered &&
          !this.isFocused &&
          !this.isDragging &&
          !document.hidden
        );
      }

      startAutoplay() {
        this.stopAutoplay();
        if (!this.canAutoplay()) return;

        const delay = Math.max(3200, Number(this.dataset.autoplaySpeed) || 5200);
        window.requestAnimationFrame(() => {
          if (this.canAutoplay()) this.classList.add('is-autoplaying');
        });

        this.autoplayTimer = window.setTimeout(() => {
          this.goTo(this.activeIndex + 1, 'autoplay');
          this.startAutoplay();
        }, delay);
      }

      stopAutoplay() {
        if (this.autoplayTimer) {
          window.clearTimeout(this.autoplayTimer);
          this.autoplayTimer = null;
        }
        this.classList.remove('is-autoplaying');
      }

      restartAutoplay() {
        this.stopAutoplay();
        this.startAutoplay();
      }

      disconnectedCallback() {
        this.stopAutoplay();
        if (this.controller) this.controller.abort();
        if (this.observer) this.observer.disconnect();
      }
    }

    customElements.define('qc-orbit-showcase', QcOrbitShowcase);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qc-quest-pack"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('qc-christmas-packs')) {
  customElements.define('qc-christmas-packs', class extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this._controller = new AbortController();
      this._timers = new Set();
      const signal = this._controller.signal;
      const q = name => this.querySelector('[data-qcq="' + name + '"]');
      const listen = (element, event, handler) => { if(element) element.addEventListener(event, handler, {signal}); };
      const delay = (handler, ms) => { const id = setTimeout(() => {this._timers.delete(id);handler();}, ms);this._timers.add(id); };
      const labels = this.dataset;
      const mascotUrl = (this.dataset.mascotUrl || '').replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/</g,'&lt;');

const garland=`<svg viewBox="0 0 1440 110" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg"><defs><filter id="charmBronze"><feFlood flood-color="#704a28"/><feComposite in2="SourceAlpha" operator="in"/></filter><filter id="charmGold"><feFlood flood-color="#d5a752"/><feComposite in2="SourceAlpha" operator="in"/></filter><filter id="charmWhite"><feFlood flood-color="#fff5d5"/><feComposite in2="SourceAlpha" operator="in"/></filter><linearGradient id="charmGloss" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="white" stop-opacity=".4"/><stop offset=".38" stop-color="white" stop-opacity=".08"/><stop offset=".43" stop-color="white" stop-opacity=".3"/><stop offset=".5" stop-color="black"/><stop offset="1" stop-color="black"/></linearGradient><mask id="charmSheen" maskUnits="userSpaceOnUse" x="-25" y="20" width="55" height="75"><rect x="-25" y="20" width="55" height="75" fill="url(#charmGloss)"/></mask><g id="sprig"><path d="M-43-9 43 9" stroke="#617969" stroke-width="2"/><g stroke="#2c5145" stroke-width="5" stroke-linecap="round"><path d="m-33-7-4-16m4 16-17 7m29-4-2-18m2 18-18 10m30-7 2-18m-2 18-17 12m30-10 2-16m-2 16-13 12m26-9 4-14m-4 14-12 13m24-10 7-12m-7 12-9 13"/></g><g stroke="#557361" stroke-width="2" stroke-linecap="round"><path d="m-30-6-3-13m3 13-12 6m24-3v-14m0 14-13 8m25-5 3-14m-3 14-11 9m24-7 4-12m-4 12-9 10m22-7 6-11m-6 11-8 10"/></g></g><radialGradient id="orb"><stop stop-color="#ffe0a1"/><stop offset="1" stop-color="#b08843"/></radialGradient></defs><path d="M-30 5Q180 88 360 20T720 20T1080 20T1470 5" fill="none" stroke="#b2955a" stroke-width="1.5"/>SPRIGS<g fill="url(#orb)"><circle cx="164" cy="66" r="10"/><circle cx="530" cy="19" r="9"/><circle cx="888" cy="58" r="10"/><circle cx="1260" cy="18" r="8"/></g><g stroke="#d8bd79" stroke-width="1"><path d="M164 43v13m366-55v9m358 25v13m372-48v10"/></g><g fill="#e9d2a0"><path d="m342 48 3 7 8 1-6 5 2 8-7-4-7 4 2-8-6-5 8-1Z"/><path d="m1070 45 3 7 8 1-6 5 2 8-7-4-7 4 2-8-6-5 8-1Z"/></g></svg>`;
let sprigs='';for(let x=-30;x<1510;x+=36){let y=20+23*Math.sin(x/115);let a=11*Math.cos(x/115);sprigs+=`<use href="#sprig" transform="translate(${x} ${y}) rotate(${a})"/>`;}let garlandSnow='';for(let n=0,x=-30;x<1510;x+=72,n++){const y=20+23*Math.sin(x/115),a=11*Math.cos(x/115),icicle=10+(n%4)*4;garlandSnow+=`<g class="garland-snow-cap" transform="translate(${x} ${y}) rotate(${a})"><path d="M-40-13Q-35-22-26-19Q-20-25-10-21Q-2-27 9-20Q18-24 26-16Q34-18 40-9L33-5Q28-2 24-6L21 ${icicle-9}Q19 ${icicle-4} 17 ${icicle-10}L15-6Q10-1 5-5L2 ${icicle}Q0 ${icicle+5}-2 ${icicle-1}L-5-6Q-11-1-17-7L-21 1Q-23 5-25-1L-28-9Q-35-5-40-13Z" fill="#cde0ef"/><path d="M-40-13Q-35-22-26-19Q-20-25-10-21Q-2-27 9-20Q18-24 26-16Q34-18 40-9Q33-5 27-9Q21-5 16-10Q10-5 4-10Q-2-5-8-10Q-15-5-21-12Q-30-6-40-13Z" fill="#f6fbff"/><path d="M-29-17Q-20-20-14-17M-4-21Q3-23 9-18" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" opacity=".8"/></g>`;}let ornaments='';[180,720,1260].forEach((x,i)=>{const y=20+23*Math.sin(x/115),drop=29+(i%2)*4;ornaments+=`<g class="mascot-ornament" transform="translate(${x} ${y})"><g class="ornament-swing" style="--charm-time:${5.5+i*.65}s;--charm-delay:-${i*1.8}s"><path class="charm-thread" d="M0 0V${drop+9}" fill="none" stroke="#dcbd7c" stroke-width="1.1"/><circle cx="0" cy="0" r="2.2" fill="#e6ca8a"/><image class="charm-depth" href="${mascotUrl}" x="-19.5" y="${drop+3}" width="44" height="53" filter="url(#charmBronze)"/><image class="charm-depth" href="${mascotUrl}" x="-20.5" y="${drop+2}" width="44" height="53" filter="url(#charmGold)"/><image class="charm-front" href="${mascotUrl}" x="-22" y="${drop}" width="44" height="53"/><image class="charm-gloss" href="${mascotUrl}" x="-22" y="${drop}" width="44" height="53" filter="url(#charmWhite)" mask="url(#charmSheen)"/><ellipse cx="0" cy="${drop+11}" rx="2.7" ry="4" fill="none" stroke="#fff0bc" stroke-width="1.4"/><path d="M-1 ${drop+8}v-3" stroke="#ad7d3e" stroke-width="1"/></g></g>`;});for(const x of [90,420,1020,1380]){const y=20+23*Math.sin(x/115);ornaments+=`<path d="M${x} ${y}v14" stroke="#e5c174"/><circle cx="${x}" cy="${y+21}" r="8" fill="#ae3044" stroke="#f3bd7966"/><circle cx="${x-2}" cy="${y+18}" r="2" fill="#ed8185"/>`;}this.querySelectorAll('.garland').forEach((g,index)=>{const prefix=this.id+'-garland-'+index+'-';let graphic=garland.replace('SPRIGS',sprigs+garlandSnow).replace('</svg>',ornaments+'</svg>');graphic=graphic.replace(/id="([^"]+)"/g,(_,id)=>'id="'+prefix+id+'"').replace(/url\(#([^)]+)\)/g,(_,id)=>'url(#'+prefix+id+')').replace(/href="#([^"]+)"/g,(_,id)=>'href="#'+prefix+id+'"');g.innerHTML=graphic;});

      const snow = this.querySelector('.snow');
      if(snow) {snow.replaceChildren();for(let i=0;i<26;i++){const flake=document.createElement('i');flake.className='flake';flake.style.cssText=`--x:${(i*37.1)%100}%;--s:${i%3+1}px;--d:${12+i%9}s;--delay:-${i*1.7}s`;snow.append(flake);}}
      const dialog=q('dialog'),trigger=q('show-content'),scene=this.querySelector('.scene');
      listen(trigger,'click',()=>{dialog.showModal();});
      listen(q('close'),'click',()=>{dialog.close();});
      listen(dialog,'click',event=>{if(event.target===dialog){const rect=dialog.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)dialog.close();}});
      listen(dialog,'close',()=>{if(trigger && this.isConnected) trigger.focus({preventScroll:true});});
      const paused=matchMedia('(prefers-reduced-motion: reduce)').matches || this.dataset.animations==='false';
      this.classList.toggle('paused',paused);
      const pack=q('rip-pack'),action=q('rip-action'),hint=q('rip-description'),status=q('rip-status');
      let open=false,busy=false,drag=null;
      scene.classList.remove('rip-open');pack.disabled=false;hint.textContent=labels.closedHint;status.textContent='';
      const rip=()=>{
        if(busy)return;
        if(open){scene.classList.remove('rip-open');open=false;busy=true;pack.disabled=true;action.textContent=labels.resealingLabel;hint.textContent=labels.closingHint;status.textContent=labels.closingHint;delay(()=>{busy=false;pack.disabled=false;action.textContent=labels.ripLabel;hint.textContent=labels.closedHint;status.textContent=labels.closedHint;},1300);return;}
        open=true;busy=true;scene.classList.add('rip-open');pack.disabled=true;action.textContent=labels.resealLabel;hint.textContent=labels.openedHint;status.textContent=labels.openedHint;delay(()=>{busy=false;},1600);
      };
      action.textContent=labels.ripLabel;
      listen(action,'click',rip);listen(pack,'click',()=>{if(!open)rip();});
      listen(pack,'pointerdown',event=>{if(!open)drag={x:event.clientX,y:event.clientY};});
      listen(pack,'pointermove',event=>{if(!drag||open)return;const dx=event.clientX-drag.x,dy=event.clientY-drag.y;if(Math.abs(dx)>42&&Math.abs(dx)>Math.abs(dy)*1.3){drag=null;rip();}});
      ['pointerup','pointercancel','pointerleave'].forEach(event=>listen(pack,event,()=>drag=null));
      for(let i=0;i<12;i++){const ribbon=document.createElement('i');ribbon.className='festive-ribbon';ribbon.setAttribute('aria-hidden','true');const side=i%2?-1:1;const colors=i%3===0?['#fff1b8','#bd8737']:i%3===1?['#ff6d70','#9e132b']:['#e3b857','#8d5d1d'];ribbon.style.cssText=`--r-x:${side*(95+Math.floor(i/2)*27)}px;--r-y:${-100-(i%4)*32}px;--r-spin:${side*(70+i*13)}deg;--r-delay:${.28+(i%4)*.035}s;--r-time:${2.05+(i%4)*.12}s;--r-scale:${.7+(i%3)*.16}`;ribbon.innerHTML=`<svg viewBox="0 0 30 100" fill="none"><path d="M15 2C-9 20 42 29 15 44S-6 68 16 77S31 90 13 98" stroke="${colors[1]}" stroke-width="6"/><path d="M14 2C-10 20 41 29 14 44S-7 68 15 77S30 90 12 98" stroke="${colors[0]}" stroke-width="3"/><path d="M12 5C0 17 23 23 23 28M8 50C-1 60 7 65 14 69M25 86L24 89" stroke="#fff3cf" stroke-opacity=".6" stroke-width="1"/></svg>`;scene.append(ribbon);}
      for(let i=0;i<18;i++){const spark=document.createElement('i');spark.className='spark';const angle=i*Math.PI*2/18;spark.style.cssText=`--sx:${Math.cos(angle)*180}px;--sy:${Math.sin(angle)*150-40}px;--delay:${.25+(i%3)*.05}s`;scene.append(spark);}
      listen(document,'shopify:block:select',event=>{if(!this.contains(event.target))return;if(event.target.closest('dialog')&&!dialog.open)dialog.showModal();});
      listen(document,'shopify:block:deselect',event=>{if(this.contains(event.target)&&dialog.open)dialog.close();});
    }
    disconnectedCallback(){this._controller?.abort();this._timers?.forEach(clearTimeout);this._timers?.clear();const dialog=this.querySelector('dialog');if(dialog?.open)dialog.close();this.querySelectorAll('.spark,.festive-ribbon').forEach(el=>el.remove());this._ready=false;}
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qc-storm-emeralda"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('qc-emerald-hero')) {
  customElements.define('qc-emerald-hero', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => { if (this.isConnected && !this.started) this.init(); });
    }
    init() {
      this.stage = this.querySelector('.qce-stage');
      this.plane = this.querySelector('.qce-plane');
      this.cards = [...this.querySelectorAll('.qce-visual')];
      if (!this.stage || !this.cards.length) return;
      this.started = true;
      this.abort = new AbortController();
      const listen = (el, event, fn, options = {}) => el.addEventListener(event, fn, { ...options, signal: this.abort.signal });
      this.tabs = [...this.querySelectorAll('[data-select]')];
      this.pauseButton = this.querySelector('.qce-pause');
      this.canvas = this.querySelector('.qce-energy');
      this.ctx = this.canvas.getContext('2d');
      this.motionQuery = matchMedia('(prefers-reduced-motion: reduce)');
      this.reduced = this.motionQuery.matches;
      this.fineQuery = matchMedia('(hover: hover) and (pointer: fine)');
      this.effects = this.dataset.effects === 'true' && !!this.ctx;
      this.lightning = this.dataset.lightning === 'true';
      this.intensity = Math.max(0, Math.min(1, Number(this.dataset.intensity) / 100 || 0));
      const color = this.dataset.energyColor.replace('#', '');
      const hex = color.length === 3 ? color.split('').map(c => c + c).join('') : color;
      this.rgb = [0, 2, 4].map(i => parseInt(hex.slice(i, i + 2), 16));
      if (this.rgb.some(c => !Number.isFinite(c))) this.rgb = [103, 218, 155];
      this.active = 0;
      this.paused = false;
      this.visible = true;
      this.editorFocus = false;
      this.hasFocus = false;
      this.clock = 0;
      this.effectTime = 0;
      this.transition = 1;
      this.px = this.py = this.tx = this.ty = 0;
      this.interval = Math.max(5, Number(this.dataset.interval) || 8);
      this.autoplay = this.dataset.autoplay === 'true';
      this.current = this.cards.map((_, i) => this.slot(i));
      this.from = this.current.map(v => ({ ...v }));
      this.dest = this.current.map(v => ({ ...v }));
      this.frame = 0;
      this.last = 0;
      this.tickBound = t => this.tick(t);
      this.tabs.forEach(b => listen(b, 'click', () => this.select(Number(b.dataset.select))));
      listen(this.pauseButton, 'click', () => {
        this.paused = !this.paused;
        this.updatePause();
        if (this.paused) {
          this.stop();
          this.drawEnergy(0);
        } else this.wake();
      });
      listen(this, 'focusin', () => { this.hasFocus = true; this.updatePause(); });
      listen(this, 'focusout', e => {
        if (!this.contains(e.relatedTarget)) { this.hasFocus = false; this.updatePause(); this.wake(); }
      });
      listen(this, 'pointermove', e => {
        if (!this.fineQuery.matches || e.pointerType !== 'mouse' || this.reduced) return;
        const r = this.getBoundingClientRect();
        this.tx = (e.clientX - r.left) / Math.max(1, r.width) * 2 - 1;
        this.ty = (e.clientY - r.top) / Math.max(1, r.height) * 2 - 1;
        this.wake();
      }, { passive: true });
      listen(this, 'pointerleave', () => { this.tx = this.ty = 0; this.wake(); });
      listen(this.stage, 'pointerdown', e => { this.startX = e.clientX; this.startY = e.clientY; });
      listen(this.stage, 'pointerup', e => {
        if (this.startX != null) {
          const dx = e.clientX - this.startX, dy = e.clientY - this.startY;
          if (Math.abs(dx) > 35 && Math.abs(dx) > Math.abs(dy)) this.select((this.active + (dx < 0 ? 1 : this.cards.length - 1)) % this.cards.length);
        }
        this.startX = null;
      });
      listen(this.stage, 'pointercancel', () => { this.startX = null; });
      listen(document, 'visibilitychange', () => { this.updatePause(); document.hidden ? this.stop() : this.wake(); });
      listen(this.motionQuery, 'change', e => {
        this.reduced = e.matches;
        this.current = this.dest.map(v => ({ ...v }));
        this.transition = 1;
        this.px = this.py = 0;
        this.paint(); this.drawEnergy(0); this.updatePause();
        this.reduced ? this.stop() : this.wake();
      });
      const link = this.querySelector('.qce-discover');
      if (link) listen(link, 'click', e => {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
        const target = this.collectionTarget();
        if (target) { e.preventDefault(); target.scrollIntoView({ behavior: this.reduced ? 'instant' : 'smooth', block: 'start' }); }
      });
      listen(document, 'shopify:block:select', e => {
        const index = this.cards.findIndex(c => c.dataset.blockId === e.detail.blockId);
        if (index < 0) return;
        this.editorFocus = true;
        this.select(index);
        this.updatePause();
      });
      listen(document, 'shopify:block:deselect', e => {
        if (!this.cards.some(c => c.dataset.blockId === e.detail.blockId)) return;
        this.editorFocus = false; this.updatePause(); this.wake();
      });
      this.resizeObserver = new ResizeObserver(() => this.resize());
      this.resizeObserver.observe(this.stage);
      this.intersectionObserver = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.updatePause();
        this.visible ? this.wake() : this.stop();
      });
      this.intersectionObserver.observe(this);
      this.resize();
      this.classList.add('is-ready');
      this.updatePause();
      this.wake();
    }
    slot(relative) {
      if (relative === 0) return { x: 0, y: 0, s: 1, r: 0, ry: -5, o: 1 };
      if (relative === 1) return { x: .68, y: -.15, s: .62, r: 13, ry: -18, o: .56 };
      return { x: -.68, y: .05, s: .62, r: -13, ry: 18, o: .56 };
    }
    select(index) {
      if (!Number.isInteger(index) || index < 0 || index >= this.cards.length || index === this.active) return;
      this.active = index;
      this.from = this.current.map(v => ({ ...v }));
      this.dest = this.cards.map((_, i) => this.slot((i - index + this.cards.length) % this.cards.length));
      this.transition = 0;
      this.clock = 0;
      this.tabs.forEach((b, i) => b.setAttribute('aria-pressed', String(i === index)));
      if (this.reduced || this.paused) {
        this.current = this.dest.map(v => ({ ...v }));
        this.transition = 1; this.paint(); this.drawEnergy(0);
      } else this.wake();
    }
    collectionTarget() {
      const id = (this.dataset.target || '').trim().replace(/^#/, '');
      if (id) return document.getElementById(id);
      if (this.dataset.scrollNext !== 'true') return null;
      let next = this.closest('.shopify-section')?.nextElementSibling;
      while (next) {
        if (next.matches('.shopify-section--featured-collection') || next.querySelector('product-list, .product-list')) return next;
        next = next.nextElementSibling;
      }
      return null;
    }
    resize() {
      this.ew = Math.max(1, this.stage.clientWidth);
      this.eh = Math.max(1, this.stage.clientHeight);
      const ratio = Math.min(window.devicePixelRatio || 1, 1.5);
      this.canvas.width = Math.round(this.ew * ratio);
      this.canvas.height = Math.round(this.eh * ratio);
      if (this.ctx) this.ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
      const safe = Math.max(0, this.ew / 2 - this.cards[0].offsetWidth * .5 - 8);
      this.unit = Math.min(this.ew * .42, safe / .68);
      this.paint();
      this.drawEnergy(0);
    }
    paint() {
      this.cards.forEach((el, i) => {
        const v = this.current[i];
        const float = this.reduced || this.paused ? 0 : Math.sin(this.effectTime * .65 + i * 1.7) * 5;
        el.style.transform = `translate(-50%,-50%) translate3d(${(v.x * this.unit).toFixed(2)}px,${(v.y * 100 + float).toFixed(2)}px,0) rotate(${v.r.toFixed(2)}deg) rotateY(${v.ry.toFixed(2)}deg) scale(${v.s.toFixed(4)})`;
        el.style.opacity = v.o.toFixed(3);
        el.style.zIndex = String(Math.round(v.s * 100));
      });
      this.plane.style.transform = `rotateY(${(this.px * 5).toFixed(2)}deg) rotateX(${(-this.py * 3).toFixed(2)}deg)`;
    }
    seed(n) { const v = Math.sin(n * 127.1 + 311.7) * 43758.5453; return v - Math.floor(v); }
    bolt(points, strength, width) {
      const ctx = this.ctx;
      ctx.beginPath();
      points.forEach((p, i) => i ? ctx.lineTo(p[0], p[1]) : ctx.moveTo(p[0], p[1]));
      ctx.strokeStyle = `rgba(${this.rgb.join(',')},${strength * .22})`; ctx.lineWidth = width * 6; ctx.stroke();
      ctx.strokeStyle = `rgba(225,255,210,${strength})`; ctx.lineWidth = width; ctx.stroke();
    }
    drawEnergy(charge) {
      const ctx = this.ctx;
      if (!ctx) return;
      const ew = this.ew, eh = this.eh, t = this.effectTime;
      ctx.clearRect(0, 0, ew, eh);
      if (!this.effects || this.reduced) return;
      const cx = ew * .5, cy = eh * .5, rx = ew * .46, ry = eh * .27;
      const intensity = this.intensity;
      ctx.globalCompositeOperation = 'lighter';
      for (let j = 0; j < 7; j++) {
        const head = t * (.25 + j * .018) + j * .89, len = 1.05 + j * .055;
        const point = q => {
          const r = 1 + j * .019;
          return [cx + Math.cos(q) * rx * r, cy + Math.sin(q) * ry * r - Math.cos(q) * eh * .16 + Math.sin(q * 2 + t * .2 + j) * eh * .025];
        };
        for (let k = 0; k < 24; k++) {
          const a = head - len + k / 24 * len, b = a + len / 24;
          const p = point(a), q = point(b), alpha = k / 24 * (.12 + charge * .20) * (j % 3 === 0 ? .65 : 1) * intensity;
          ctx.beginPath();ctx.moveTo(...p);ctx.lineTo(...q);ctx.lineWidth = j % 3 === 0 ? 1.6 : .7;
          ctx.strokeStyle = j === 0 ? `rgba(240,198,90,${alpha})` : `rgba(${this.rgb.join(',')},${alpha})`;ctx.stroke();
        }
      }
      for (let i = 0; i < 22; i++) {
        const a = this.seed(i + 2) * Math.PI * 2 + t * (.11 + this.seed(i + 6) * .11), r = .82 + this.seed(i + 12) * .28;
        const x = cx + Math.cos(a) * rx * r, y = cy + Math.sin(a) * ry * r - Math.cos(a) * eh * .16;
        const alpha = (.16 + .16 * Math.sin(t + i)) * (.7 + charge * .4) * intensity;
        ctx.fillStyle = i % 6 === 0 ? `rgba(240,198,90,${alpha})` : `rgba(${this.rgb.join(',')},${alpha})`;
        ctx.beginPath();ctx.ellipse(x, y, 1.1, 1.8, -.7, 0, Math.PI * 2);ctx.fill();
      }
      if (charge > .001 && this.lightning) {
        const points = [];
        for (let k = 0; k <= 13; k++) {
          const f = k / 13;
          points.push([ew * (.83 - .22 * f) + (this.seed(k + this.active * 19) - .5) * ew * .045, eh * (.08 + .67 * f)]);
        }
        this.bolt(points, charge * .68 * intensity, .9);
        [4, 7, 10].forEach((n, i) => {
          const start = points[n], end = [start[0] + ew * (i % 2 ? -.17 : .12), start[1] + eh * .13];
          this.bolt([start, [start[0] + (end[0] - start[0]) * .55, start[1] + eh * .025], end], charge * .4 * intensity, .55);
        });
        const glow = ctx.createRadialGradient(ew * .74, eh * .3, 0, ew * .74, eh * .3, ew * .35);
        glow.addColorStop(0, `rgba(${this.rgb.join(',')},${charge * .09 * intensity})`);glow.addColorStop(1, `rgba(${this.rgb.join(',')},0)`);
        ctx.fillStyle = glow;ctx.fillRect(0, 0, ew, eh);
      }
      ctx.globalCompositeOperation = 'source-over';
    }
    tick(time) {
      this.frame = 0;
      if (!this.isConnected || this.reduced || this.paused || !this.visible || document.hidden) return;
      const dt = this.last ? Math.max(0, Math.min((time - this.last) / 1000, .05)) : 0;
      this.last = time;
      this.clock += dt;
      this.effectTime += dt;
      this.transition = Math.min(1, this.transition + dt / 1.8);
      const t = this.transition, ease = t * t * t * (t * (t * 6 - 15) + 10);
      this.current = this.from.map((v, i) => Object.fromEntries(Object.keys(v).map(k => [k, v[k] + (this.dest[i][k] - v[k]) * ease])));
      const a = 1 - Math.exp(-dt * 5);
      this.px += (this.tx - this.px) * a;this.py += (this.ty - this.py) * a;
      this.paint();
      const charge = this.clock < 2.2 ? Math.pow(Math.sin(Math.PI * Math.min(1, this.clock / 2.2)), 4) : 0;
      if (!this.energyLast || time - this.energyLast > 32) { this.drawEnergy(charge);this.energyLast = time; }
      if (this.autoplay && !this.editorFocus && !this.hasFocus && this.cards.length > 1 && this.clock > this.interval) this.select((this.active + 1) % this.cards.length);
      if (!this.frame) this.frame = requestAnimationFrame(this.tickBound);
    }
    wake() {
      if (!this.started || this.frame || this.reduced || this.paused || !this.visible || document.hidden) return;
      this.last = 0;
      this.frame = requestAnimationFrame(this.tickBound);
    }
    stop() { if (this.frame) cancelAnimationFrame(this.frame);this.frame = 0;this.last = 0; }
    updatePause() {
      if (!this.pauseButton) return;
      this.pauseButton.disabled = this.reduced;
      this.pauseButton.textContent = this.reduced ? this.dataset.staticLabel : (this.paused ? this.dataset.resumeLabel : this.dataset.pauseLabel);
      this.pauseButton.setAttribute('aria-pressed', String(this.paused));
      this.classList.toggle('is-paused', this.paused || this.reduced || !this.visible || document.hidden);
    }
    disconnectedCallback() {
      this.stop();
      this.abort?.abort();
      this.resizeObserver?.disconnect();this.intersectionObserver?.disconnect();
      this.started = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qc-transition-narrative"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('qc-narrative-transition')) {
    class QCNarrativeTransition extends HTMLElement {
      connectedCallback() {
        if (this.dataset.qcReady === 'true') return;
        this.dataset.qcReady = 'true';

        this.video = this.querySelector('video');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.pointerMoveHandler = this.handlePointerMove.bind(this);
        this.pointerResetHandler = this.resetPointer.bind(this);

        if (this.reducedMotion) {
          this.classList.add('is-visible');
          if (this.video) this.video.pause();
        } else {
          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                this.classList.toggle('is-visible', entry.isIntersecting);
                if (!this.video) return;

                if (entry.isIntersecting) {
                  const playPromise = this.video.play();
                  if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(() => {});
                } else {
                  this.video.pause();
                }
              });
            },
            { threshold: 0.18 }
          );

          this.observer.observe(this);

          if (this.classList.contains('qc-transition--product-media') && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
            this.addEventListener('pointermove', this.pointerMoveHandler);
            this.addEventListener('pointerleave', this.pointerResetHandler);
          }
        }

        QCNarrativeTransition.initializeStoryline();
        QCNarrativeTransition.initializeWhyCarousel();
        QCNarrativeTransition.scheduleStoryline();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        this.removeEventListener('pointermove', this.pointerMoveHandler);
        this.removeEventListener('pointerleave', this.pointerResetHandler);
        QCNarrativeTransition.scheduleStoryline();
      }

      handlePointerMove(event) {
        const rect = this.getBoundingClientRect();
        const x = ((event.clientX - rect.left) / rect.width - 0.5) * 10;
        const y = ((event.clientY - rect.top) / rect.height - 0.5) * 8;
        this.style.setProperty('--qc-media-x', `${x}px`);
        this.style.setProperty('--qc-media-y', `${y}px`);
      }

      resetPointer() {
        this.style.setProperty('--qc-media-x', '0px');
        this.style.setProperty('--qc-media-y', '0px');
      }

      static initializeStoryline() {
        if (this.storylineInitialized) return;
        this.storylineInitialized = true;

        window.addEventListener('resize', () => this.scheduleStoryline(), { passive: true });
        window.addEventListener(
          'scroll',
          () => {
            if (this.storylineScrollFrame) return;
            this.storylineScrollFrame = requestAnimationFrame(() => {
              this.storylineScrollFrame = null;
              this.updateStoryProgress();
            });
          },
          { passive: true }
        );

        document.addEventListener('shopify:section:load', () => {
          this.initializeWhyCarousel();
          this.scheduleStoryline();
        });
        document.addEventListener('shopify:section:reorder', () => this.scheduleStoryline());

        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(() => this.scheduleStoryline());
        }
      }

      static scheduleStoryline() {
        if (this.storylineRenderFrame) cancelAnimationFrame(this.storylineRenderFrame);
        this.storylineRenderFrame = requestAnimationFrame(() => {
          this.storylineRenderFrame = null;
          this.renderStoryline();
        });
      }

      static initializeWhyCarousel() {
        const root = document.querySelector('#qcWhy2');
        const list = root ? root.querySelector('.qw2-list') : null;
        if (!list) return;

        /* Le ruban est gere par qc-why-buy : aucun slider, compteur ou scroll automatique ici. */
        list.dataset.qcMobileCarousel = 'continuous';
        root.querySelectorAll('.qc-why-mobile-meter').forEach((meter) => meter.remove());
      }

      static initializeStorySections() {
        const chapters = [
          document.querySelector('.qc-ae2__inner'),
          document.querySelector('#qcWhy2')
        ].filter(Boolean);
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        chapters.forEach((chapter, index) => {
          chapter.classList.add('qc-story-proof', `qc-story-proof--${index + 1}`);

          const wrapper = chapter.closest('.shopify-section');
          if (wrapper) wrapper.classList.add('qc-story-chapter');
          if (chapter.dataset.qcStoryReady === 'true') return;

          chapter.dataset.qcStoryReady = 'true';
          if (reducedMotion || !('IntersectionObserver' in window)) {
            chapter.classList.add('qc-story-visible', 'qc-story-settled');
            return;
          }

          const observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                chapter.classList.add('qc-story-visible');
                window.setTimeout(() => chapter.classList.add('qc-story-settled'), 950);
                observer.disconnect();
              });
            },
            { threshold: 0.12, rootMargin: '0px 0px -12% 0px' }
          );

          observer.observe(chapter);
        });

        const endChapter = document.querySelector('.qc-orbit');
        const endWrapper = endChapter && endChapter.closest('.shopify-section');
        if (endWrapper) endWrapper.classList.add('qc-story-chapter', 'qc-story-chapter--end');
      }

      static renderStoryline() {
        this.initializeStorySections();

        const transitions = Array.from(
          document.querySelectorAll('qc-narrative-transition[data-story-line="true"]')
        ).filter((transition) => transition.offsetParent !== null);
        const main = document.querySelector('main');

        const startChapter = document.querySelector('.qc-ae2__inner');
        const middleChapter = document.querySelector('#qcWhy2');
        const endChapter = document.querySelector('.qc-orbit__shell') || document.querySelector('.qc-orbit');

        if (!main || transitions.length < 2 || !startChapter || !middleChapter || !endChapter) {
          const existing = document.querySelector('.qc-storyline');
          if (existing) existing.remove();
          return;
        }

        const firstNode = transitions[0].querySelector('.qc-transition__story-node');
        const lastNode = transitions[transitions.length - 1].querySelector('.qc-transition__story-node');
        if (!firstNode || !lastNode) return;

        main.classList.add('qc-storyline-host');

        const namespace = 'http://www.w3.org/2000/svg';
        let svg = main.querySelector(':scope > .qc-storyline');

        if (!svg) {
          svg = document.createElementNS(namespace, 'svg');
          svg.classList.add('qc-storyline');
          svg.setAttribute('aria-hidden', 'true');

          const basePath = document.createElementNS(namespace, 'path');
          basePath.classList.add('qc-storyline__base');
          const progressPath = document.createElementNS(namespace, 'path');
          progressPath.classList.add('qc-storyline__progress');
          const cursor = document.createElementNS(namespace, 'rect');
          cursor.classList.add('qc-storyline__cursor');
          cursor.setAttribute('x', '-10');
          cursor.setAttribute('y', '-2');
          cursor.setAttribute('width', '20');
          cursor.setAttribute('height', '4');
          cursor.setAttribute('rx', '2');

          svg.append(basePath, progressPath, cursor);
          main.append(svg);
        }

        const mainRect = main.getBoundingClientRect();
        const firstRect = firstNode.getBoundingClientRect();
        const lastRect = lastNode.getBoundingClientRect();
        const startRect = startChapter.getBoundingClientRect();
        const middleRect = middleChapter.getBoundingClientRect();
        const endRect = endChapter.getBoundingClientRect();
        const width = main.clientWidth;
        const height = main.scrollHeight;
        const firstX = firstRect.left - mainRect.left + firstRect.width / 2;
        const firstY = firstRect.top - mainRect.top + firstRect.height / 2;
        const lastX = lastRect.left - mainRect.left + lastRect.width / 2;
        const lastY = lastRect.top - mainRect.top + lastRect.height / 2;
        const startY = startRect.top - mainRect.top + Math.min(54, startRect.height * 0.08);
        const endY = endRect.top - mainRect.top - 5;
        const mobile = window.matchMedia('(max-width: 749px)').matches;

        let pathData;
        if (mobile) {
          const guideX = firstX;
          pathData = [
            `M ${guideX} ${startY}`,
            `L ${guideX} ${firstY}`,
            `L ${guideX} ${lastY}`,
            `L ${guideX} ${endY}`
          ].join(' ');
        } else {
          const startX = Math.max(28, startRect.left - mainRect.left - 28);
          const startBottomY = startRect.bottom - mainRect.top - 44;
          const middleSideX = Math.max(28, middleRect.left - mainRect.left - 44);
          const middleTopY = middleRect.top - mainRect.top + 34;
          const middleBottomY = middleRect.bottom - mainRect.top - 34;
          const endX = endRect.left - mainRect.left + endRect.width / 2;

          pathData = [
            `M ${startX} ${startY}`,
            `C ${startX} ${startY + 92}, ${startX} ${startBottomY - 70}, ${startX} ${startBottomY}`,
            `C ${startX} ${startBottomY + 54}, ${firstX - 108} ${firstY - 46}, ${firstX} ${firstY}`,
            `C ${firstX + 34} ${firstY + 58}, ${middleSideX} ${middleTopY - 66}, ${middleSideX} ${middleTopY}`,
            `L ${middleSideX} ${middleBottomY}`,
            `C ${middleSideX} ${middleBottomY + 62}, ${lastX - 78} ${lastY - 58}, ${lastX} ${lastY}`,
            `C ${lastX} ${lastY + 58}, ${endX} ${endY - 72}, ${endX} ${endY}`
          ].join(' ');
        }

        svg.setAttribute('viewBox', `0 0 ${width} ${height}`);
        svg.setAttribute('width', String(width));
        svg.setAttribute('height', String(height));
        svg.style.height = `${height}px`;

        const basePath = svg.querySelector('.qc-storyline__base');
        const progressPath = svg.querySelector('.qc-storyline__progress');
        basePath.setAttribute('d', pathData);
        progressPath.setAttribute('d', pathData);

        const pathLength = progressPath.getTotalLength();
        progressPath.style.strokeDasharray = String(pathLength);
        progressPath.dataset.pathLength = String(pathLength);
        svg.dataset.startY = String(startRect.top + window.scrollY + Math.min(54, startRect.height * 0.08));
        svg.dataset.endY = String(endRect.top + window.scrollY - 5);

        this.updateStoryProgress();
      }

      static updateStoryProgress() {
        const svg = document.querySelector('.qc-storyline');
        if (!svg) return;

        const progressPath = svg.querySelector('.qc-storyline__progress');
        const pathLength = Number(progressPath.dataset.pathLength || 0);
        const startY = Number(svg.dataset.startY || 0);
        const endY = Number(svg.dataset.endY || 0);
        if (!pathLength || endY <= startY) return;

        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const readingLine = window.scrollY + window.innerHeight * 0.7;
        const progress = reducedMotion ? 1 : Math.min(1, Math.max(0, (readingLine - startY) / (endY - startY)));
        progressPath.style.strokeDashoffset = String(pathLength * (1 - progress));

        const cursor = svg.querySelector('.qc-storyline__cursor');
        if (!cursor) return;

        const distance = Math.min(pathLength, Math.max(0, pathLength * progress));
        const beforeDistance = Math.max(0, distance - 1);
        const afterDistance = Math.min(pathLength, distance + 1);
        const point = progressPath.getPointAtLength(distance);
        const before = progressPath.getPointAtLength(beforeDistance);
        const after = progressPath.getPointAtLength(afterDistance);
        const angle = Math.atan2(after.y - before.y, after.x - before.x) * (180 / Math.PI);

        cursor.setAttribute('transform', `translate(${point.x} ${point.y}) rotate(${angle})`);
        cursor.style.opacity = !reducedMotion && progress > 0.015 && progress < 0.985 ? '1' : '0';
      }
    }

    customElements.define('qc-narrative-transition', QCNarrativeTransition);
  }

  } catch(e) { console.error(e); }
})();
})();
